export const getTagsFromString = (
  tags: string[] | undefined
): Record<string, boolean> | undefined => {
  if (!tags || tags.length === 0) {
    return
  }

  const processedTags: Record<string, boolean> = {}
  tags.forEach((tag: string) => {
    processedTags[tag] = true
  })

  return processedTags
}
